import { PartialType, OmitType } from '@nestjs/swagger';
import { CreatePresentacionDto } from './create-presentacion.dto';

export class UpdatePresentacionDto extends PartialType(
  OmitType(CreatePresentacionDto, ['producto_id'] as const),
) {}
